import { createContext, useContext } from "react";
import { missingText, type Label, type Locale } from "./texts";

// Lo que una pantalla puede pedirle al marco sin recargar (R7 · Mi cuenta): volver a leer la sesión (el nombre nuevo en
// la cabecera) y aplicar el tema y el idioma recién guardados (Preferencias se aplican al guardar, sin recargar).

export type Theme = "SYSTEM" | "LIGHT" | "DARK";

export type AppActions = {
  refreshSession: () => Promise<void>;
  /** Aplica tema e idioma y devuelve los textos ya en el idioma nuevo (para el aviso de guardado). */
  applyPreferences: (locale: Locale, theme: Theme) => Promise<Label>;
};

export const AppContext = createContext<AppActions>({
  refreshSession: async () => undefined,
  applyPreferences: async () => missingText,
});

export const useApp = () => useContext(AppContext);

/** Pinta el tema como theme-init.js: SYSTEM sigue al sistema operativo. */
export function paintTheme(theme: Theme, root: HTMLElement = document.documentElement) {
  const effective =
    theme === "SYSTEM"
      ? window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light"
      : theme.toLowerCase();
  root.setAttribute("data-theme", effective);
}
